var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-base',{attrs:{"levy-collection-id":_vm.levyCollectionId,"provider-id":_vm.providerId,"task":_vm.task,"user-guide-topic":"levy-collection-providers","user-guide-section":"running-a-levy-collection-provider-task"},on:{"run":_vm.run,"hide":_vm.hide},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})
}
var staticRenderFns = []

export { render, staticRenderFns }